module.exports = __webpack_public_path__ + "static/media/house.b713ba2f.svg";